module.exports = __webpack_public_path__ + "static/plots-769aa3982b255857dccd75c4131de26b.png";